import { Label } from "../model/Label";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

export const translateLabel = async (label: Label): Promise<Label | null> => {
  const response = await axiosInstance.post<ApiResponse<Label>>(`/api/label/translate`, label);
  return response.data.data;
};
